(function () {
  function initSizeGuide(root) {
    const scope = root || document.getElementById('VrvSizeGuide');
    if (!scope || scope.dataset.vrvTabsBound) return;
    scope.dataset.vrvTabsBound = 'true';

    const tabs = scope.querySelectorAll('[data-vrv-size-tab]');
    const panels = scope.querySelectorAll('[data-vrv-size-panel]');
    if (!tabs.length || !panels.length) return;

    function activate(id) {
      tabs.forEach((tab) => {
        const on = tab.dataset.vrvSizeTab === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        const on = panel.dataset.vrvSizePanel === id;
        panel.hidden = !on;
        panel.classList.toggle('is-active', on);
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab.dataset.vrvSizeTab));
    });
  }

  document.addEventListener('DOMContentLoaded', () => initSizeGuide());
})();
